import React from 'react'

class PublishBtn extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			publishing: false
		}
		this.handleClick = this.handleClick.bind(this)
	}
	
	handleClick() {
		/*this.setState({
			publishing: true
		})*/
		this.props.handlePublish()
	}
	
	render() {
		return (
			<div className="d-flex align-items-center">
				<button type="button" className="btn btn-submit" onClick={ this.handleClick } >Publish</button>
				{ this.state.publishing ? (<span className="loading-txt">Publishing...</span>):(null) }
			</div>
		)
	}
}

class UnpublishBtn extends React.Component {
	
	handleClick() {
		this.props.handleUnpublish()
	}
	
	render() {
		return (
			<div className="d-flex align-items-center ml-auto">
				<button type="button" className="btn btn-save" onClick={ this.handleClick.bind(this) } >Unpublish</button>
			</div>
		)
	}
}

class SaveBtn extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			saving: false,
			saved: false
		}
		this.handleClick = this.handleClick.bind(this)
		this.toggleSave = this.toggleSave.bind(this)
	}
	
	handleClick() {
		this.setState({
			saving: true,
			saved: false
		})
		this.props.handleSave(this.toggleSave)
	}
	
	toggleSave() {
		this.setState({
			saving: false,
			saved: true
		})
	}
	
	render() {
		return (
			<div className="d-flex align-items-center ml-auto">
				{ this.state.saving ? (<span className="saving-txt">Saving...</span>):(null) }
				{ this.state.saved ? (<div className="success-wrap"><span className="saved-txt">Saved</span><span className="success-icon mr-2"><svg viewBox="0 0 512 512"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path></svg></span></div>):(null) }
				<button type="button" className="btn btn-save" onClick={ this.handleClick } >Save</button>
			</div>
		)
	}
}

class UpdateBtn extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			updating: false,
			updated: false
		}
		this.handleClick = this.handleClick.bind(this)
		this.toggleUpdate = this.toggleUpdate.bind(this)
	}
	
	handleClick() {
		this.setState({
			updating: true
		})
		this.props.handleUpdate(this.toggleUpdate)
	}
	
	toggleUpdate() {
		this.setState({
			updating: false,
			updated: true
		})
	}
	
	render() {
		return (
			<div className="d-flex align-items-center">
				<button type="button" className="btn btn-submit" onClick={ this.handleClick } >Update</button>
				{ this.state.updating ? (<span className="updating-txt">Updating...</span>):(null) }
				{ this.state.updated ? (<div className="success-wrap"><span className="updated-txt">Updated</span><span className="success-icon ml-1"><svg viewBox="0 0 512 512"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path></svg></span></div>):(null) }
			</div>
		)
	}
}

class BaseBar extends React.Component {
	render() {
		
		const { handlePublish, handleUnpublish, handleUpdate, handleSave, published } = this.props
				
		if (!published) {
			return (
				<div className="basebar d-flex align-items-center">
					<PublishBtn handlePublish={ handlePublish } />
					<SaveBtn handleSave={ handleSave } />
				</div>
			)
		}
		return (
			<div className="basebar d-flex align-items-center">
				<UpdateBtn handleUpdate={ handleUpdate } />
				<UnpublishBtn handleUnpublish={ handleUnpublish } />
			</div>
		)
	}
}

export default BaseBar


// WEBPACK FOOTER //
// ./src/components/Editor/BaseBar.js